import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const LocationTemplatesPage = lazy(
  () => import("../../../../components/WMS/Warehouses/LocationTemplatesPage"),
)

export const Route = createFileRoute(
  "/_layout/WMS/warehouses/location-templates",
)({
  component: LocationTemplatesRoute,
})

function LocationTemplatesRoute() {
  return (
    <LazyRoutePage>
      <LocationTemplatesPage />
    </LazyRoutePage>
  )
}
